var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm._.rule},[_c('div',{class:_vm._.label},[_vm._v("拼单规则")]),_c('div',{class:_vm._.value},[_vm._v("好友拼单·人满发货·人不满退款")])])}
var staticRenderFns = []

export { render, staticRenderFns }